import { render, staticRenderFns } from "./Basket.vue?vue&type=template&id=5fe3783e&"
import script from "./Basket.vue?vue&type=script&lang=js&"
export * from "./Basket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unnamed777/projects/zetton.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fe3783e')) {
      api.createRecord('5fe3783e', component.options)
    } else {
      api.reload('5fe3783e', component.options)
    }
    module.hot.accept("./Basket.vue?vue&type=template&id=5fe3783e&", function () {
      api.rerender('5fe3783e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Basket.vue"
export default component.exports